import React from 'react';
import { Box, Typography, Link } from '@mui/material';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        px: { xs: 2, md: 4 },
        py: 3,
        mt: 4,
        borderTop: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '0.8125rem' }}>
        &copy; 2026, Maintenance AI. All Rights Reserved.
      </Typography>
      <Box sx={{ display: 'flex', gap: 2 }}>
        <Link
          href="#"
          underline="hover"
          sx={{ color: 'text.secondary', fontSize: '0.8125rem' }}
        >
          Privacy
        </Link>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          &middot;
        </Typography>
        <Link
          href="#"
          underline="hover"
          sx={{ color: 'text.secondary', fontSize: '0.8125rem' }}
        >
          Terms
        </Link>
      </Box>
    </Box>
  );
};

export default Footer;
